import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'activeFilterName'
})
export class ActiveFilterNamePipe implements PipeTransform {

  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case 'Search By Reference Code': {
        return 'Search By Code';
      }
      default: return value;
    }
  }

}
